<div class="container-fluid">

<h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-book mr-2"></i> 3D Library Viewer
  </h1>
  
  <p class="lead mb-4">
    The 3D Library Viewer allows you to explore and interact with a virtual library. View shelves and books in a 3D environment, manage their placement, and get details on each book such as titles and cover images. Enhance the user experience with dynamic scene rendering and seamless controls.
  </p>

  

</div>

<form>
  <label for="department">Select Department:</label>
  <select id="department" (change)="onSelectChange($event)">
    <option></option>
    <option *ngFor="let department of departments" [value]="department.departmentCode">
      {{ department.departmentName }}
    </option>
  </select>
</form>

<div #rendererContainer></div>